var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-pb-style":_vm.content.pbStyle}},_vm._l((_vm.products),function(product){return _c('ProductBox',{key:("products-" + (product.sku)),attrs:{"product":product,"custom-tag":_vm.customTag}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }